<template>
  <div>
    <template v-if="productsDiscounts.length === 0">
      <span class="text-primary">
        Brak przypisanych rabatów.
      </span>
    </template>
    <template v-else>
      <d-row
        v-for="(discount, index) of productsDiscounts"
        :key="'manufacturer-discount-item-' + index"
        :class="{
          'my-2 pb-2 mx-0': true,
          'border-bottom': index < (productsDiscounts.length -1)
        }">
        <d-col sm="10" class="pl-0">
          <strong>{{ retriveProductName(discount.id) }}</strong>
        </d-col>
        <d-col sm="2" class="text-left text-sm-right pr-0 pl-sm-1 pl-0">
          <span class="text-success">
            <strong>{{ discount.discount }} %</strong>
          </span>
        </d-col>
      </d-row>
    </template>
  </div>
</template>

<script>
export default {
  name: 'product-discount-info',
  props: [
    'productsDiscounts',
    'allProducts'
  ],
  methods: {
    retriveProductName(productID) {
      if (!this.allProducts.length) {
        return '';
      }

      return this.allProducts.find(product => product.id === productID).name;
    }
  }
}
</script>
